import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class PaperPlaneBadge extends WritingBadge {
  public readonly id = BadgeId.paperPlane;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.wordsCount >= 25000;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/paperPlane.ts